import { render, staticRenderFns } from "./DirForm.vue?vue&type=template&id=cdba7546"
import script from "./DirForm.vue?vue&type=script&lang=js"
export * from "./DirForm.vue?vue&type=script&lang=js"
import style0 from "./DirForm.vue?vue&type=style&index=0&id=cdba7546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports